import React from "react";
import ENresume from "../../pages/EN-resume/ENresume";
import UKRresume from "../../pages/UKR-resume/ukrResume";
import { Route, Routes } from "react-router";
import "./styles.css";
export const Main = () => {
  return (
    <main>
      <Routes>
        <Route path="/" element={<ENresume />} />
        <Route path="/ukr" element={<UKRresume />} />
      </Routes>
    </main>
  );
};
